import { useState } from 'react';
import styled from 'styled-components';
import Header from '@/components/mo/Review/Header';
import SummaryCard from '@/components/mo/Review/SummaryCard';
import FilterBar from '@/components/mo/Review/FilterBar';
// import ReviewCard from '@/components/mo/Review/ReviewCard';
// import NoResult from '@/components/mo/Review/NoResult';
// import { useReviews } from '@/hooks/useReviews';
import FilterModal from '@/components/mo/Review/FilterModal';
import PcReviewPage from '@/components/pc/Review';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';

const ReviewPage = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 600 });
  const [openModal, setOpenModal] = useState(false);

  const handleConfirm = (filters: { 보험종류: string; 사고유형: string }) => {
    const params = new URLSearchParams();
    params.set('type', filters.보험종류);
    params.set('issue', filters.사고유형);

    navigate({
      pathname: '/review',
      search: params.toString(),
    });

    setOpenModal(false);
  };

  if (!isMobile) {
    return <PcReviewPage />;
  }

  return (
    <>
      <Header />
      <ContentWrapper>
        <SummaryCard />
        <FilterBar
          onOpenModal={() => setOpenModal(true)} // ✅ 수정
        />
        <FilterModal
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onConfirm={handleConfirm} // ✅ 요거만 바꾸면 됨
        />
      </ContentWrapper>
    </>
  );
};

export default ReviewPage;

const ContentWrapper = styled.div`
  padding: 0 16px;
  margin: 0 auto;
`;
